export default [
    {
        // [0]
        key: "employee_id",
        label: "Employee",
        sortable: true,
        visible: true,
    },
    {
        // [1]
        key: "motivo_adelanto_sueldo",
        label: "Motivo",
        visible: true,
    },
    {
        // [1]
        key: "status",
        label: "Status",
        visible: true,
    },
    {
        // [2]
        key: "total",
        label: "Amount",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [3]
        key: "quotas",
        label: "Quotas",
        thClass: "text-center",
        tdClass: "text-center",
        visible: true,
    },
    {
        // [4]
        key: "created_by",
        label: "Created By",
        sortable: true,
        visible: true,
    },
    {
        // [4]
        key: "user_authorized",
        label: "Aprobado Por",
        sortable: true,
        visible: true,
    },
    {
        // [5]
        key: "observacion",
        label: "Observation",
        visible: true,
    },
    {
        // [5]
        key: "sustento",
        label: "Archivos",
        visible: true,
    },
    // {
    //     // [5]
    //     key: "compromiso",
    //     label: "Compromiso",
    //     visible: true,
    // },
    {
        // [6]
        key: "actions",
        label: "Actions",
        visible: true,
        tdClass: "text-center",
        thClass: "text-center",
    },
]